import * as z from "zod";
import { aeoDashboardFilterInput } from "./types";

const sovBrandPoint_ = z.object({ name: z.string(), sov: z.number() });

const sovTimeSeriesPoint_ = z.object({
  date: z.string(),
  brands: z.array(sovBrandPoint_),
});

const sovLeaderboardEntry_ = z.object({
  rank: z.number().int(),
  name: z.string(),
  website: z.string(),
  isYou: z.boolean(),
  sov: z.number(),
  trend: z.number().nullable(),
});

export const getAeoDashboardShareOfVoice = {
  name: "getAeoDashboardShareOfVoice" as const,
  input: aeoDashboardFilterInput,
  output: z.object({
    timeSeries: z.array(sovTimeSeriesPoint_),
    leaderboard: z.array(sovLeaderboardEntry_),
  }),
};
